export const environmentsActions = {
    SET_ENVIRONMENT: 'SET_ENVIRONMENT',
    GET_ENVIRONMENT: 'GET_ENVIRONMENT',
    GET_VERSIONS_FOR_SET: 'GET_VERSIONS_FOR_SET',
    SET_VERSIONS_FOR_SET: 'SET_VERSIONS_FOR_SET',
    SET_TO_VERSION: 'SET_TO_VERSION',
    SET_TO_VERSION_FAILED: 'SET_TO_VERSION_FAILED',
    GET_VERSIONS_FOR_UPGRADE: 'GET_VERSIONS_FOR_UPGRADE',
    SET_VERSIONS_FOR_UPGRADE: 'SET_VERSIONS_FOR_UPGRADE',
    UPGRADE_PREVALIDATE_TO_VERSION: 'UPGRADE_PREVALIDATE_TO_VERSION',
    APPLY_LABEL: 'APPLY_LABEL',
    SET_TYPE: 'SET_TYPE',
    SET_ENV_TYPES: 'SET_ENV_TYPES',
    GET_ENV_TYPES: 'GET_ENV_TYPES',
    GET_PACKAGES_FOR_ROLLBACK: 'GET_PACKAGES_FOR_ROLLBACK',
    SET_PACKAGES_FOR_ROLLBACK: 'SET_PACKAGES_FOR_ROLLBACK',
    GET_PACKAGES_FOR_VALIDATE: 'GET_PACKAGES_FOR_VALIDATE',
    SET_PACKAGES_FOR_VALIDATE: 'SET_PACKAGES_FOR_VALIDATE',
    ROLLBACK: 'ROLLBACK',
    GET_ENV_SETTINGS: 'GET_ENV_SETTINGS',
    SET_ENV_SETTINGS: 'SET_ENV_SETTINGS',
    GET_ENV_DETAILS: 'GET_ENV_DETAILS',
    SET_ENV_DETAILS: 'SET_ENV_DETAILS',
    SAVE_ENV_SETTINGS: 'SAVE_ENV_SETTINGS',
    GET_LABELS: 'GET_LABELS',
    SET_LABELS: 'SET_LABELS',
    VALIDATE: 'VALIDATE',
    VALIDATE_BY_PACKAGE: 'VALIDATE_BY_PACKAGE',
    BUILD: 'BUILD',
    BUILDBYTASK: 'BUILDBYTASK',
    EXIT_INTEGRATION: 'EXIT_INTEGRATION',
    FAILUR: 'FAILUR',
    GET_ENV_SCHEMA: 'GET_ENV_SCHEMA',
    GET_LABELS_FOR_VALIDATE: 'GET_LABELS_FOR_VALIDATE',
    SET_LABELS_FOR_VALIDATE: 'SET_LABELS_FOR_VALIDATE',
    VALIDATE_BY_LABEL: 'VALIDATE_BY_LABEL',
    GET_LABELS_FOR_ROLLBACK: 'GET_LABELS_FOR_ROLLBACK',
    SET_LABELS_FOR_ROLLBACK: 'SET_LABELS_FOR_ROLLBACK',
    ROLLBACK_DOWNGRADE_BY_TASK: 'ROLLBACK_DOWNGRADE_BY_TASK',
    GET_PACKAGES_FOR_DEPLOY_BY_TASK: 'GET_PACKAGES_FOR_DEPLOY_BY_TASK',
    GET_PACKAGES_FOR_ROLLBACK_BY_TASK: 'GET_PACKAGES_FOR_ROLLBACK_BY_TASK',
    GET_PACKAGES_FOR_DEPLOY_BY_VERSION: 'GET_PACKAGES_FOR_DEPLOY_BY_VERSION',
    UPGRADE_PREVALIDATE_BY_TASK: 'UPGRADE_PREVALIDATE_BY_TASK',
    ROLLBACK_BY_LABEL: 'ROLLBACK_BY_LABEL',
    UPDATE_DEV_ENV: 'UPDATE_DEV_ENV',
    RUN_PACKAGE: 'RUN_PACKAGE',
    GET_BASELINE_FOR_GET_LATEST: 'GET_BASELINE_FOR_GET_LATEST'
};

const initState = {
    list: [],
    versionsForUpgrade: [],
    versionsForSet: [],
    envTypes: [],
    envSettings: {},
    envDetails: {},
    labels: []
};

export const environmentsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case environmentsActions.SET_ENVIRONMENT:
            return Object.assign({}, state, action.payload);

        case environmentsActions.SET_VERSIONS_FOR_UPGRADE:
            return Object.assign({}, state, action.payload);

        case environmentsActions.SET_VERSIONS_FOR_SET:
            return Object.assign({}, state, action.payload);

        case environmentsActions.GET_ENV_TYPES:
            return Object.assign({}, state, { envTypes: action.payload });

        case environmentsActions.SET_ENV_DETAILS:
        case environmentsActions.SET_ENV_SETTINGS:
            return Object.assign({}, state, action.payload);

        case environmentsActions.SET_TO_VERSION_FAILED:
            return Object.assign({}, state, action.payload);

        case environmentsActions.SET_LABELS:
            return Object.assign({}, state, action.payload);

        case environmentsActions.SET_LABELS:
            return Object.assign({}, state, action.payload);

        case environmentsActions.SET_PACKAGES_FOR_ROLLBACK:
        case environmentsActions.SET_PACKAGES_FOR_VALIDATE:
        case environmentsActions.SET_LABELS_FOR_VALIDATE:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/environmentsReducer.ts